// const orderLayout = resolve => require(['./toursOrder/layout.vue'], resolve);
// const dashboard = resolve => require(['../dashboard.vue'], resolve);
export default [
  {
    path: "/approval/:inviteCode",
    // component: invite,
    component: (resolve) => require(["./approval.vue"], resolve),
  },
  {
    name: "dashboard",
    children: [
      {
        path: "/order/flight/Change",
        name: "OrderFlightCNChange",
        meta: {
          requiresAuth: true,
        },
        component: (resolve) => require(["./flightCN/Change.vue"], resolve),
      },
      {
        path: "/order/flightGJ/Change/:OrderID?",
        name: "OrderFlightGJChange",
        component: (resolve) => require(["./flightGJdetails/Change.vue"], resolve),
      },
      {
        path: "/order/detail",
        name: "OrderDetails",
        component: (resolve) => require(["./details.vue"], resolve),
      },
      // {
      //     path: '/order/all/list/:state?',
      //     name: 'OrderList',
      //     component: resolve => require(['./list.vue'], resolve)
      // },
      {
        path: "/order/:service?/list/:state?",
        name: "OrderList",
        component: (resolve) => require(["./list.vue"], resolve),
      },
      {
        path: "/oldorder/:service?/detail/:applyarea?/:id?/:demand?",
        name: "olddetail",
        component: (resolve) => require(["./olddetail.vue"], resolve),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/order/router.js